import React, { Component, Fragment } from "react";
import ReportScope, { readReportScope } from '../../reports/report-scope';
import { injectIntl } from "react-intl";
var classNames = require("classnames");
import API from "../../../api/index";
import { Row, Card, Button, Input, Form, FormGroup, CardTitle, Label, Collapse, CardBody, Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import { logoutUser } from "Redux/actions";
import { connect } from "react-redux";
import moment from "jalali-moment";
import { Colxx } from "Components/CustomBootstrap";
import "react-circular-progressbar/dist/styles.css";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import StateButton from "Components/StateButton";
import Tooltip from "react-simple-tooltip";
import NumberFormat from "react-number-format";
import CustomerMobileLookup, { parentCustomerMobileObject } from "Components/CustomerMobileLookup";

import { DatePicker, RangeDatePicker } from "jalali-react-datepicker";
import { NotificationManager } from "Components/ReactNotifications";

class CouponIndex extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isRefreshing: false,
			modalCreateCouponOpen: false,
			collapseFilterOpen: true,
			tab: "ALL",
			search: {
				reportContext: readReportScope(props.location.search),
				couponCode: "",
				couponCodeOperator: "=",
				couponSubject: "",
				couponSubjectOperator: "=",
				couponDescription: "",
				couponType: "ALL",
				couponCreatedAt: "",
				couponExpiresAt: "",

				couponUsage: "ALL",
				couponExpiration: "ALL",
				currentPage: 1,
			},
			APISearchData: {},
			searchReset: null,
			newCoupon: {
				code: "",
				amount: "",
				type: "%",
				subject: "",
				customerID: -1,
				isLead: false,
				LeadID: -1,
				expire: "",
				limit: 1,
				minSpend: 0,
				description: "",
			},
			newCouponReset: null,
			newCouponButtonClicked: false,
			customerMobile: parentCustomerMobileObject,
			coupons: [],
			isLoading: true,
		};
		this.customerMobileLookupComponent = React.createRef();

		this.handleCustomerMobileChange = this.handleCustomerMobileChange.bind(this);

		this.tabChanged = this.tabChanged.bind(this);
		this.modalCreateCouponToggle = this.modalCreateCouponToggle.bind(this);
		this.collapseFilterToggle = this.collapseFilterToggle.bind(this);
		this.validateSearchFilter = this.validateSearchFilter.bind(this);
		this.validateNewCouponFilter = this.validateNewCouponFilter.bind(this);
		this.setCouponCreatedDateRange = this.setCouponCreatedDateRange.bind(this);
		this.setCouponExpireDateRange = this.setCouponExpireDateRange.bind(this);
		this.setNewCouponExpireDate = this.setNewCouponExpireDate.bind(this);
		this.remainingDays = this.remainingDays.bind(this);
		this.componentDidMount = this.componentDidMount.bind(this);
		this.handleCouponCreateReset = this.handleCouponCreateReset.bind(this);
		this.handleSearchReset = this.handleSearchReset.bind(this);
		this.validateCouponCreation = this.validateCouponCreation.bind(this);
		this.handleCreateCouponButtonClick = this.handleCreateCouponButtonClick.bind(this);
		this.loadData = this.loadData.bind(this);
		this.doSearch = this.doSearch.bind(this);
	}
	handleFocus = (event) => event.target.select();
	handleCustomerMobileChange(customerMobileObject) {
		this.setState({ customerMobile: customerMobileObject });
		if (customerMobileObject.isCustomer) {
			var tmpObj = { ...this.state.newCoupon };
			tmpObj.customerID = customerMobileObject.customerObject.ID;
			this.setState({ newCoupon: tmpObj });
		}else{
			var tmpObj = { ...this.state.newCoupon };
			tmpObj.customerID =-1;
			this.setState({ newCoupon: tmpObj });
		}
	}
	handleCouponCreateReset() {
		// reset newCoupon to the initial state
		const newCouponResetTemp = this.state.newCouponReset;
		this.setState({ newCoupon: { ...newCouponResetTemp } });
		this.customerMobileLookupComponent.current.reset();
	}
	handleSearchReset() {
		// reset newCoupon to the initial state
		const newSearchResetTemp = this.state.searchReset;
		this.setState({ search: { ...newSearchResetTemp }, APISearchData: { ...this.state.searchReset } }, () => {
			this.loadData();
		});
	}

	setCouponCreatedDateRange(range, param) {
		var tmpObj = this.state.search;
		tmpObj.couponCreatedAt = range;
		this.setState({ search: tmpObj });
	}
	setCouponExpireDateRange(range, param) {
		var tmpObj = this.state.search;
		tmpObj.couponExpiresAt = range;
		this.setState({ search: tmpObj });
	}
	setNewCouponExpireDate(date) {
		var dataTime = date.value._i.replace("-//", "T23:59:59");
		var tmpObj = this.state.newCoupon;
		tmpObj.expire = dataTime;
		this.setState({ newCoupon: tmpObj });
	}
	remainingDays(date) {
		const targetDate = new Date(date);
		const today = new Date();
		const timeDiff = targetDate.getTime() - today.getTime();
		const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));

		if (daysDiff <= 0) {
			return "منقضی";
		} else {
			return `${daysDiff} روز`;
		}
	}
	validateNewCouponFilter(filter, value) {
		if (value === undefined) {
			return false;
		}
		switch (filter) {
			case "coupon-code":
				var pattern = /^[a-zA-Z0-9-]+$/;
				var match = pattern.test(value);
				if ((value.length > 5) & match) {
					return true;
				}
				break;
			case "coupon-amount":
				if (this.state.newCoupon.type == "%") {
					if (value > 0 && value < 101) {
						return true;
					}
				} else {
					if (value > 1000) {
						return true;
					}
				}
				break;
			case "coupon-subject":
				if (value.length > 5) {
					return true;
				}
				break;
			case "coupon-customer":
				if (this.state.customerMobile.isCustomer || this.state.customerMobile.mobile == "") {
					return true;
				}
				break;
			case "coupon-expire":
				if (value != "" && this.remainingDays(value) !== "منقضی") {
					return true;
				}
				break;
			case "coupon-limit":
				if (value > 0) {
					return true;
				}
				break;
			case "coupon-minspend":
				if (value >= 0) {
					return true;
				}
				break;
			case "coupon-description":
				if (value.length > 0) {
					return true;
				}
				break;
		}
		return false;
	}
	validateCouponCreation() {
		const filters = {
			"coupon-code": this.state.newCoupon.code,
			"coupon-amount": this.state.newCoupon.amount,
			"coupon-subject": this.state.newCoupon.subject,
			"coupon-expire": this.state.newCoupon.expire,
			"coupon-limit": this.state.newCoupon.limit,
			"coupon-minspend": this.state.newCoupon.minSpend,
			"coupon-customer": this.state.customerMobile.isCustomer,
			"coupon-description": this.state.newCoupon.description,
		};

		for (const [key, value] of Object.entries(filters)) {
			if (key === "coupon-limit" && value === 1) {
				continue; // skip this filter if the value is the default
			}
			if (key === "coupon-minspend" && value === 0) {
				continue; // skip this filter if the value is the default
			}
			if (key === "coupon-customer" && this.state.customerMobile.mobile == "") {
				continue; // skip this filter if the value is the default
			}
			if (key === "coupon-description" && value === "") {
				continue; // skip this filter if the value is the default
			}
			if (!this.validateNewCouponFilter(key, value)) {
				return false;
			}
		}

		return true;
	}
	validateSearchFilter(filter, value) {
		switch (filter) {
			case "coupon-code":
				var pattern = /^[a-zA-Z0-9-]+$/;
				var match = pattern.test(value);
				if ((value.length > 0) & match) {
					return true;
				}
				break;
			case "coupon-subject":
				if (value.length > 0) {
					return true;
				}
				break;
			case "coupon-description":
				if (value.length > 0) {
					return true;
				}
				break;
		}
		return false;
	}
	collapseFilterToggle() {
		this.setState({
			collapseFilterOpen: !this.state.collapseFilterOpen,
		});
	}
	modalCreateCouponToggle() {
		this.setState({
			modalCreateCouponOpen: !this.state.modalCreateCouponOpen,
		});
	}
	componentDidMount() {
		const newCouponReset = { ...this.state.newCoupon };
		const searchReset = { ...this.state.search };
		const apiSerachData = { ...this.state.search };
		this.setState(
			{
				newCouponReset: { ...newCouponReset },
				searchReset: { ...searchReset },
				APISearchData: { ...apiSerachData },
			},
			() => {
				this.loadData();
			}
		);
	}
	tabChanged(index) {
		var tabs = [];
		tabs[0] = "ALL";
		tabs[1] = "BIRTHDAY";
	}

	handleCreateCouponButtonClick() {
		return new Promise((success, fail, $this) => {
			
			this.setState({ newCouponButtonClicked: true });
			API.post("crm/coupon/add", this.state.newCoupon)
				.then((data) => {
					data.RELOGIN ? this.props.logoutUser(this.props.history) : 0;

					if (data.ERRORS !== undefined) {
						fail("خطا در ثبت کوپن");
						for (var i = 0; i < data.ERRORS.length; i++) {
							setTimeout(
								function (err) {
									NotificationManager.error(err, "خطا در ثبت کوپن", 8000, null, null, "filled");
								},
								(i + 1) * 700,
								data.ERRORS[i]
							);
							this.setState({
								newCouponButtonClicked: false,
							});
						}
					} else {
						success("کوپن ثبت شد");
						setTimeout(() => {
							this.setState({ newCouponButtonClicked: false, modalCreateCouponOpen: false });
							this.loadData();
						}, 1000);
					}
				})
				.catch((error) => {
					fail("خطا در ثبت کوپن");
				});
		});
	}
	doSearch() {
		var tmpObj = JSON.parse(JSON.stringify(this.state.search));
		tmpObj.currentPage = 1;
		this.setState(
			{
				APISearchData: tmpObj,
				isRefreshing: true,
			},
			() => {
				this.loadData();
			}
		);
	}
	loadData() {
		this.setState({ reportError: '' });
		API.post("crm/coupon/list", this.state.APISearchData)
			.then((data) => {
				data.RELOGIN ? this.props.logoutUser(this.props.history) : 0;
				this.setState({
					coupons: data.coupons,
					paging: data.paging,
					isLoading: false,
					isRefreshing: false,
				});
			})
			.catch((error) => { this.setState({ isLoading: false, isRefreshing: false, reportError: 'دریافت فهرست ناموفق بود؛ دسترسی یا فیلتر گزارش را بررسی کنید.', paging: {pages:[],total:0,from:0,to:0,current:1}, orders:[],customers:[],leads:[],coupons:[] }); });
	}
	render() {
		return this.state.isLoading ? (
			<div className="loading"></div>
		) : (
			<Fragment>
				<Row>
					<Colxx xl="12">
						<Tabs defaultIndex={this.props.location.state == undefined ? 0 : this.props.location.state.tabDefaultIndex} onSelect={(index) => this.tabChanged(index)}>
							<TabList>
								<Tab default={true}>
									{/* <div className={"simple-icon-list headingicon"} /> */}
									همه
								</Tab>
								<Tab>
									{/* <div className={"iconsminds-cake headingicon"} /> */}
									تولد
								</Tab>
							</TabList>

							<TabPanel>
								<Card>
							<CardBody>
								<ReportScope scope={this.state.search.reportContext} error={this.state.reportError} />
										<CardTitle>
											<div className={"iconsminds-pantone headingicon"} />
											همه کوپن ها
											<Button
												color="primary"
												outline
												style={{ float: "left" }}
												className={"default"}
												onClick={() => {
													this.setState({ modalCreateCouponOpen: true });
												}}
											>
												<i className="iconsminds-add icon-size-20" style={{ fontWeigh: "bold" }}></i>&nbsp; کوپن جدید
											</Button>
											<Modal size="lg" isOpen={this.state.modalCreateCouponOpen} toggle={this.modalCreateCouponToggle}>
												<ModalHeader toggle={this.modalCreateCouponToggle}>ایجاد کوپن</ModalHeader>
												<ModalBody>
													<Row>
														<Colxx sm={4}>
															<FormGroup className={"filter " + (this.validateNewCouponFilter("coupon-code", this.state.newCoupon.code) ? "filter-active" : "")}>
																<Label for="newCouponCode">کد کوپن *</Label>

																<Input
																	type="text"
																	name="newCouponCode"
																	style={{ width: "100%" }}
																	id="newCouponCode"
																	onClick={this.handleFocus}
																	placeholder="ABC-100"
																	value={this.state.newCoupon.code}
																	onChange={(e) => {
																		var tmpObj = { ...this.state.newCoupon };
																		tmpObj.code = e.target.value;
																		this.setState({ newCoupon: tmpObj });
																	}}
																/>
															</FormGroup>
														</Colxx>
														<Colxx sm={4}>
															<FormGroup className={"filter " + (this.validateNewCouponFilter("coupon-amount", this.state.newCoupon.amount) ? "filter-active" : "")}>
																<Label for="newCouponAmount" style={{ width: "100%" }}>
																	مقدار *
																</Label>
																{/* <Input
															type="text"
															name="newCouponAmount"
															style={{ width: "60%", display: "inline-block", float: "right" }}
															id="newCouponAmount"
															onClick={this.handleFocus}
															placeholder="10"
															value={this.state.newCoupon.amount}
															onChange={(e) => {
																var tmpObj = { ...this.state.newCoupon };
																tmpObj.amount = e.target.value;
																this.setState({ newCoupon: tmpObj });
															}}
														/> */}
																<NumberFormat
																	value={this.state.newCoupon.amount}
																	onClick={this.handleFocus}
																	onValueChange={(values) => {
																		var tmpObj = { ...this.state.newCoupon };
																		tmpObj.amount = values.value;
																		this.setState({ newCoupon: tmpObj });
																	}}
																	style={{ width: "60%", height: "40px", border: "1px solid #d7d7d7", display: "inline-block", float: "right" }}
																	thousandSeparator={true}
																/>
																<span
																	style={{
																		border: "1px solid lightgray",
																		borderRadius: "5px",
																		background: "#eaeaea",
																		cursor: "pointer",
																		marginRight: 10,
																		display: "inline-block",
																		width: "30%",
																		height: "40px",
																		lineHeight: "30px",
																		textAlign: "center",
																		paddingTop: "5px",
																		paddingLeft: "10px",
																		paddingRight: "10px",
																		textAlign: "center",
																		flaot: "left",
																	}}
																	onClick={(e) => {
																		var tmpObj = { ...this.state.newCoupon };
																		tmpObj.type = this.state.newCoupon.type == "%" ? "تومان" : "%";
																		this.setState({ newCoupon: tmpObj });
																	}}
																>
																	{this.state.newCoupon.type == "%" ? "%" : "تومان"}
																</span>
															</FormGroup>
														</Colxx>
														<Colxx sm={4}>
															<FormGroup className={"filter " + (this.validateNewCouponFilter("coupon-subject", this.state.newCoupon.subject) ? "filter-active" : "")}>
																<Label for="newCouponSubject">موضوع کوپن *</Label>

																<Input
																	type="text"
																	name="newCouponSubject"
																	style={{ width: "100%" }}
																	id="newCouponSubject"
																	onClick={this.handleFocus}
																	placeholder="BIRTHDAY"
																	value={this.state.newCoupon.subject}
																	onChange={(e) => {
																		var tmpObj = { ...this.state.newCoupon };
																		tmpObj.subject = e.target.value;
																		this.setState({ newCoupon: tmpObj });
																	}}
																/>
															</FormGroup>
														</Colxx>
													</Row>
													<Row className={"mb-4"}>
														<Colxx sm={4}>
															<FormGroup className={"filter " + (this.validateNewCouponFilter("coupon-expire", this.state.newCoupon.expire) ? "filter-active" : "")}>
																<Label for="newCouponCode">تاریخ انقضاء *</Label>
																<span className="text-muted" style={{ float: "left" }}>
																	{this.state.newCoupon.expire == "" ? <></> : this.remainingDays(this.state.newCoupon.expire)}
																</span>
																<DatePicker timePicker={false} label="تاریخ انقضا" onClickSubmitButton={this.setNewCouponExpireDate} />
															</FormGroup>
														</Colxx>
														<Colxx sm={4}>
															<FormGroup className={"filter " + (this.validateNewCouponFilter("coupon-limit", this.state.newCoupon.limit) ? "filter-active" : "")}>
																<Label for="newCouponLimit">دفعات قابل استفاده *</Label>
																<NumberFormat
																	name="newCouponLimit"
																	id="newCouponLimit"
																	value={this.state.newCoupon.limit}
																	onClick={this.handleFocus}
																	onValueChange={(values) => {
																		var tmpObj = { ...this.state.newCoupon };
																		tmpObj.limit = values.value;
																		this.setState({ newCoupon: tmpObj });
																	}}
																	style={{ width: "100%", padding: "10px", height: "40px", border: "1px solid #d7d7d7", display: "inline-block" }}
																	thousandSeparator={true}
																/>
															</FormGroup>
														</Colxx>
														<Colxx sm={4}>
															<FormGroup className={"filter " + (this.validateNewCouponFilter("coupon-minspend", this.state.newCoupon.minSpend) ? "filter-active" : "")}>
																<Label for="newCouponLimit">حداقل مبلغ سفارش (تومان)</Label>
																<NumberFormat
																	name="newCouponLimit"
																	id="newCouponLimit"
																	value={this.state.newCoupon.minSpend}
																	onClick={this.handleFocus}
																	onValueChange={(values) => {
																		var tmpObj = { ...this.state.newCoupon };
																		tmpObj.minSpend = values.value;
																		this.setState({ newCoupon: tmpObj });
																	}}
																	style={{ width: "100%", padding: "10px", height: "40px", border: "1px solid #d7d7d7", display: "inline-block" }}
																	thousandSeparator={true}
																/>
															</FormGroup>
														</Colxx>
													</Row>
													<Row>
														<Colxx sm={4}>
															<CustomerMobileLookup
																isValid={this.state.customerMobile.isValid && this.state.customerMobile.isCustomer}
																ref={this.customerMobileLookupComponent}
																customerMobileObject={this.state.customerMobile}
																onCustomerMobileChange={this.handleCustomerMobileChange}
															/>
														</Colxx>
														<Colxx sm={8}>
															<FormGroup className={"filter " + (this.validateNewCouponFilter("coupon-description", this.state.newCoupon.description) ? "filter-active" : "")}>
																<Label for="newCouponDescription">توضیحات</Label>

																<Input
																	type="text"
																	name="newCouponDescription"
																	id="newCouponDescription"
																	onClick={this.handleFocus}
																	placeholder="برای تشویق مشتری..."
																	value={this.state.newCoupon.description}
																	onChange={(e) => {
																		var tmpObj = { ...this.state.newCoupon };
																		tmpObj.description = e.target.value;
																		this.setState({ newCoupon: tmpObj });
																	}}
																/>
															</FormGroup>
														</Colxx>
													</Row>
												</ModalBody>
												<ModalFooter>
													<Button
														color="light"
														style={{
															float: "left",
															marginLeft: "10px",
															marginTop: "-14px",
														}}
														className={"default"}
														onClick={this.handleCouponCreateReset}
													>
														ریست
													</Button>
													<StateButton disabled={!this.validateCouponCreation()} id="newBatchSaveButton" color="primary" className="mb-3 default" onClick={() => this.handleCreateCouponButtonClick()}>
														ثبت
													</StateButton>
												</ModalFooter>
											</Modal>
										</CardTitle>
										<Fragment>
											<div className="border productPanel">
												<Button block color="link" className="text-right" onClick={() => this.collapseFilterToggle()} aria-expanded={this.state.collapseFilterOpen}>
													<i className="glyph-icon simple-icon-magnifier" style={{ marginLeft: "5px", fontSize: "14px" }}></i>
													فرم جستجو
													<i className="glyph-icon simple-icon-arrow-down" style={{ marginRight: "10px", fontSize: "10px" }}></i>
												</Button>

												<div
													className="dropdown-buttons"
													style={{
														float: "left",
														display: this.state.collapseFilterOpen ? "inline-block" : "none",
													}}
												>
													<Button
														color="primary"
														className={"default"}
														style={{
															float: "left",
															marginLeft: "10px",
														}}
														onClick={this.doSearch}
													>
														جستجو کن
													</Button>
													<Button
														color="light"
														style={{
															float: "left",
															marginLeft: "10px",
														}}
														className={"default"}
														onClick={this.handleSearchReset}
													>
														ریست
													</Button>
												</div>
												<Collapse isOpen={this.state.collapseFilterOpen} style={{ marginTop: "0px" }}>
													<div className="" style={{ padding: "20px", paddingBottom: 0 }}>
														<Row className="mb-4">
															<Colxx xxs="12">
																<Form>
																	<FormGroup row>
																		<Colxx sm={3}>
																			<FormGroup className={"filter " + (this.validateSearchFilter("coupon-code", this.state.search.couponCode) ? "filter-active" : "")}>
																				<Label for="couponCode">کد کوپن</Label>
																				<span
																					style={{
																						border: "1px solid lightgray",
																						borderRadius: "5px",
																						background: "#eaeaea",
																						cursor: "pointer",
																						marginRight: 10,
																						display: "inline-block",
																						width: "25px",
																						textAlign: "center",
																						paddingTop: "5px",
																					}}
																					onClick={(e) => {
																						var tmpObj = { ...this.state.search };
																						tmpObj.couponCodeOperator = this.state.search.couponCodeOperator == "=" ? "*" : "=";
																						this.setState({ search: tmpObj });
																					}}
																				>
																					{this.state.search.couponCodeOperator == "=" ? "=" : "*"}
																				</span>
																				<Input
																					type="text"
																					name="couponCode"
																					id="couponCode"
																					onClick={this.handleFocus}
																					placeholder="ABCDEF"
																					value={this.state.search.couponCode}
																					onChange={(e) => {
																						var tmpObj = { ...this.state.search };
																						tmpObj.couponCode = e.target.value;
																						this.setState({ search: tmpObj });
																					}}
																				/>
																			</FormGroup>
																			<FormGroup className={"filter " + (this.state.search.couponType != "ALL" ? "filter-active" : "")}>
																				<Label>نوع کوپن</Label>
																				<Input
																					type="select"
																					onChange={(e) => {
																						var tmpObj = { ...this.state.search };
																						tmpObj.couponType = e.target.value;
																						this.setState({ search: tmpObj });
																					}}
																					value={this.state.search.couponType}
																				>
																					<option value="ALL">همه نوع</option>
																					<option value="PERCENT">درصدی</option>
																					<option value="FIXED">مبلغ ثابت</option>
																				</Input>
																			</FormGroup>
																		</Colxx>
																		<Colxx sm={3}>
																			<FormGroup className={"filter " + (this.validateSearchFilter("coupon-subject", this.state.search.couponSubject) ? "filter-active" : "")}>
																				<Label for="couponSubject">موضوع کوپن</Label>
																				<span
																					style={{
																						border: "1px solid lightgray",
																						borderRadius: "5px",
																						background: "#eaeaea",
																						cursor: "pointer",
																						marginRight: 10,
																						display: "inline-block",
																						width: "25px",
																						textAlign: "center",
																						paddingTop: "5px",
																					}}
																					onClick={(e) => {
																						var tmpObj = { ...this.state.search };
																						tmpObj.couponSubjectOperator = this.state.search.couponSubjectOperator == "=" ? "*" : "=";
																						this.setState({ search: tmpObj });
																					}}
																				>
																					{this.state.search.couponSubjectOperator == "=" ? "=" : "*"}
																				</span>
																				<Input
																					type="text"
																					name="couponSubject"
																					id="couponSubject"
																					onClick={this.handleFocus}
																					placeholder="تولد"
																					value={this.state.search.couponSubject}
																					onChange={(e) => {
																						var tmpObj = { ...this.state.search };
																						tmpObj.couponSubject = e.target.value;
																						this.setState({ search: tmpObj });
																					}}
																				/>
																			</FormGroup>

																			<FormGroup style={{ marginBottom: 0 }} className={"filter " + (this.validateSearchFilter("coupon-description", this.state.search.couponDescription) ? "filter-active" : "")}>
																				<Label for="couponDescription">توضیحات کوپن (شامل)</Label>
																				<Input
																					type="text"
																					name="couponDescription"
																					id="couponDescription"
																					onClick={this.handleFocus}
																					placeholder=""
																					value={this.state.search.couponDescription}
																					onChange={(e) => {
																						var tmpObj = { ...this.state.search };
																						tmpObj.couponDescription = e.target.value;
																						this.setState({ search: tmpObj });
																					}}
																				/>
																			</FormGroup>
																		</Colxx>
																		<Colxx sm={2}>
																			<FormGroup className={"filter " + (this.state.search.couponUsage != "ALL" ? "filter-active" : "")}>
																				<Label> وضعیت مصرف</Label>
																				<Input
																					type="select"
																					onChange={(e) => {
																						var tmpObj = { ...this.state.search };
																						tmpObj.couponUsage = e.target.value;
																						this.setState({ search: tmpObj });
																					}}
																					value={this.state.search.couponUsage}
																				>
																					<option value="ALL">همه</option>
																					<option value="ENTIRELY">کامل مصرف شده</option>
																					<option value="PARTIALLY">بخشی مصرف شده</option>
																					<option value="NOTUSED">مصرف نشده</option>
																				</Input>
																			</FormGroup>
																			<FormGroup className={"filter " + (this.state.search.couponExpiration != "ALL" ? "filter-active" : "")}>
																				<Label> وضعیت انقضا</Label>
																				<Input
																					type="select"
																					onChange={(e) => {
																						var tmpObj = { ...this.state.search };
																						tmpObj.couponExpiration = e.target.value;
																						this.setState({ search: tmpObj });
																					}}
																					value={this.state.search.couponExpiration}
																				>
																					<option value="ALL">همه</option>
																					<option value="EXPIRED">منقضی شده</option>
																					<option value="NOTEXPIRED">منقضی نشده</option>
																				</Input>
																			</FormGroup>
																		</Colxx>
																		<Colxx sm={2}>
																			<FormGroup className={"filter " + (this.state.search.couponCreatedAt != "" ? "filter-active" : "")}>
																				<Button
																					style={{
																						float: "left",
																						padding: "5px",
																						color: "black",
																						backgroundColor: "transparent",
																						border: "unset",
																						display: this.state.search.couponCreatedAt != "" ? "block" : "none",
																					}}
																					onClick={(e) => {
																						var tmpObj = { ...this.state.search };
																						tmpObj.couponCreatedAt = "";
																						this.setState({ search: tmpObj });
																					}}
																				>
																					<i className="simple-icon-close"></i>
																				</Button>
																				<div className="datepicker">
																					<RangeDatePicker fromLabel="ثبت شده از تاریخ" toLabel="ثبت شده تا تاریخ" onClickSubmitButton={this.setCouponCreatedDateRange} />
																				</div>
																			</FormGroup>
																		</Colxx>
																		<Colxx sm={2}>
																			<FormGroup className={"filter " + (this.state.search.couponExpiresAt != "" ? "filter-active" : "")}>
																				<Button
																					style={{
																						float: "left",
																						padding: "5px",
																						color: "black",
																						backgroundColor: "transparent",
																						border: "unset",
																						display: this.state.search.couponExpiresAt != "" ? "block" : "none",
																					}}
																					onClick={(e) => {
																						var tmpObj = { ...this.state.search };
																						tmpObj.couponExpiresAt = "";
																						this.setState({ search: tmpObj });
																					}}
																				>
																					<i className="simple-icon-close"></i>
																				</Button>
																				<RangeDatePicker fromLabel="انقضا از تاریخ" toLabel="انقضا تا تاریخ" onClickSubmitButton={this.setCouponExpireDateRange} />
																			</FormGroup>
																		</Colxx>
																	</FormGroup>
																</Form>
															</Colxx>
														</Row>
													</div>
												</Collapse>
											</div>
											<br />
										</Fragment>
										{!this.state.isRefreshing ? (
											<div className="table-responsive">
												<table className="table table-hover order-table">
													<thead>
														<tr>
															<th>کوپن</th>
															<th>موضوع</th>
															<th>مقدار</th>
															{/* ۱۰٪ یا ۱۰،۰۰۰ تومان */}
															{/* روش بیاد توضیحات بیاد */}
															<th>حداقل سفارش</th>
															<th>انقضا</th>
															{/* تاریخ + مانده / منقضی شد */}
															<th>مصرف شده</th>
															{/* مثلا ۱/۱ */}
														</tr>
													</thead>

													{this.state.coupons.map((row) => (
														<TabAllTableRows key={row.couponID} data={row} />
													))}

													<tfoot>
														<tr>
															<td colSpan={12}>
																<div className="table-pagination">
																	{this.state.paging.pages.map((page, index) => (
																		<Button
																			key={index}
																			className={classNames({ "mb-2": true, "pagination-item": true, "pagination-number": true, "pagination-current": page.current })}
																			onClick={(e) => {
																				if (page.ellipse) {
																					return;
																				}
																				var tmpObj = { ...this.state.APISearchData };
																				tmpObj.currentPage = page.page;

																				this.setState({ APISearchData: tmpObj, isRefreshing: true }, () => {
																					this.loadData();
																				});
																			}}
																		>
																			{page.page}
																		</Button>
																	))}

																	<div className={"text-muted"} style={{ display: "block", clear: "both", marginTop: "16px", fontSize: "14px" }}>
																		نمایش {this.state.paging.from + 1} - {Math.min(this.state.paging.to, this.state.paging.total)} از {this.state.paging.total} کوپن
																	</div>
																</div>
															</td>
														</tr>
													</tfoot>
												</table>
											</div>
										) : (
											<div className="loading" style={{ left: "unset", top: "unset", position: "relative", display: "block", marginLeft: "auto", marginRight: "auto" }}></div>
										)}
									</CardBody>
								</Card>
							</TabPanel>
							<TabPanel>
								<Card>
									<CardBody>
										<CardTitle>
											<div className={"iconsminds-cake headingicon"} />
											کوپن‌های هدیه تولد
										</CardTitle>
										{/* {this.state.isLoading ? <div className="loading loading-inline"></div> : this.state.batches.map((row) => <BatchItem key={row.BatchID} data={row} />)} */}
									</CardBody>
								</Card>
							</TabPanel>
						</Tabs>
					</Colxx>
				</Row>
			</Fragment>
		);
	}
}

class TabAllTableRows extends Component {
	render() {
		const {
			data: { couponID, code, isUseable, isExpired, description, type, createdAt, subject, amount, minSpend, expiresAt, usage, operatorName },
		} = this.props;
		const typeMappings = {
			PERCENT: "%",
			FIXED: "تومان",
		};
		const created = "ایجاد: " + moment(createdAt).locale("fa").format("DD / MMMM / YYYY - HH:mm") + " " + operatorName;
		return (
			<tbody>
				<tr className={"order-spacer"}></tr>
				<tr className={"order-item"}>
					<td>
						<a href={"/app/crm/coupon/view/" + couponID} target="_blank">
							{" "}
							<div className="coupon" style={{ color: isUseable == false ? "red" : "#556270" }}>
								<span>{code}</span>
							</div>{" "}
							<div className={" simple-icon-arrow-left-circle icongotoorder"} />
						</a>
					</td>
					<td className={"text-muted"}>{description == null ? subject : <Tooltip content={description}>{subject}</Tooltip>}</td>
					<td className={"text-muted"}>
						{" "}
						<NumberFormat style={{ textAlign: "center" }} value={amount} className="text-muted" displayType={"text"} suffix={" " + typeMappings[type]} thousandSeparator={true} renderText={(value, prop) => <div>{value}</div>} />
					</td>
					<td className={"text-muted"}>
						<NumberFormat style={{ textAlign: "center" }} value={minSpend} className="text-muted" displayType={"text"} suffix={" تومان"} thousandSeparator={true} renderText={(value, prop) => <div>{value}</div>} />
					</td>
					<td style={{ color: isExpired == "1" ? "red" : "green" }}>
						<Tooltip content={created}>{moment(expiresAt).locale("fa").format("DD / MMMM / YYYY - HH:mm")}</Tooltip>
					</td>
					<td className={"text-muted"}>{usage}</td>
				</tr>
			</tbody>
		);
	}
}

const mapStateToProps = ({ menu, settings }) => {
	return { logoutUser };
};
export default injectIntl(connect(mapStateToProps, { logoutUser })(CouponIndex));
